import React from "react";
import Nav from "./Nav";
import styled from "styled-components"

export default function Purchase (){
  return(
    <PurchaseWrapper>
    <Nav/>
    <div class="construction">
    </div>
    </PurchaseWrapper>
  )
}
const PurchaseWrapper = styled.div`

`
